import { Config } from 'config/envConfig';
import React, { createContext, useContext, useEffect, useState } from 'react';
import { getUrl } from '../components/pdfDisplay/utils';

const AdminContext = createContext();

export const useAdmin = () => useContext(AdminContext);

export const AdminProvider = ({ children }) => {
    const [adminList, setAdminList] = useState([]);

    useEffect(() => {
        const fetchAdminList = async () => {
            try {
                const userStr = localStorage.getItem('current');
                if (!userStr) {
                    // No logged-in user — skip fetching silently
                    setAdminList([]);
                    return;
                }

                const user = JSON.parse(userStr);
                const token = user?.token;
                if (!token) {
                    // No token — skip silently
                    setAdminList([]);
                    return;
                }

                const encodedToken = encodeURIComponent(token);
                const response = await fetch(
                    getUrl(
                        `http://${Config.NODE_SERVER_HOST}:${Config.NODE_SERVER_PORT}/AdminList`
                    ),
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: encodedToken,
                        },
                    }
                );

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const result = await response.json();
                setAdminList(result);
            } catch (error) {
                console.error('Error fetching admin list:', error);
                setAdminList([]);
                // No alert or popup — fail silently
            }
        };

        fetchAdminList();
    }, []);

    return (
        <AdminContext.Provider value={adminList}>
            {children}
        </AdminContext.Provider>
    );
};
